import React from 'react';
import {
  useTranslation,
  Button,
  eventBus,
  trackHotjarEvent,
} from '@lib/index';
import { ReviewDocumentProps } from './types';

const ReviewDocument = ({
  file,
  worker,
  stencil,
  disabled,
  onOpenReview,
}: ReviewDocumentProps) => {
  const { t } = useTranslation();

  const handleOpenModal = () => {
    eventBus.dispatch('handleClosePopOver', {});
    if (onOpenReview) {
      onOpenReview(file, worker, stencil);
    }
    trackHotjarEvent('document_review_opened');
  };

  return (
    <Button onClick={handleOpenModal} type="link" disabled={disabled}>
      {t('utils.sendDocumentation.review')}
    </Button>
  );
};

export default ReviewDocument;
